import React from 'react';
import {
  Card,
  Col,
  Modal,
  Row,
} from 'react-bootstrap';

import './index.scss';

export default function About({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="confirmation-dialog-modal"
    >
      <Modal.Header
        closeButton
        className="confirmation-dialog-modal-header"
      >
        <Modal.Title className="ms-4">
          INSTRUÇÕES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Row className="align-items-stretch">
          <Col md={6}>
            <Card className="h-100 water-balance-sequential-instruction-card">
              <Card.Header className="shadow-sm">
                SOBRE
              </Card.Header>
              <Card.Body>
                O balanço hídrico sequencial monitora, de forma contínua, a
                {' '}
                <strong>entrada e saída de água no solo,</strong>
                {' '}
                considerando a precipitação
                e a evapotranspiração potencial. Ele permite identificar períodos de
                {' '}
                <strong>déficit e excedente hídrico</strong>
                {' '}
                ao longo do tempo,
                independentemente da presença de culturas agrícolas, sendo uma ferramenta
                essencial para avaliar a disponibilidade de água no solo em diferentes
                regiões. É possível consultar o balanço hídrico de forma
                {' '}
                <strong>espacial,</strong>
                {' '}
                visualizando mapas do Brasil com dados de
                armazenamento, déficit e excedente hídrico, ou de forma
                {' '}
                <strong>pontual</strong>
                {' '}
                , analisando uma localidade específica.
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="water-balance-sequential-instruction-card">
              <Card.Header>INSTRUÇÕES PARA CONSULTA DO BALANÇO HÍDRICO</Card.Header>
              <Card.Body>
                <p><strong>Consulta por localidade</strong></p>
                Preencha as informações no painel de controle da aba
                {' '}
                <strong>Visão Detalhada</strong>
                :
                <div className="d-flex flex-row instruction-item m-1 mt-2">
                  <div className="instruction-number instruction-marker me-2">1</div>
                  <div className="instruction-text">Informe o local desejado.</div>
                </div>
                <div className="d-flex flex-row instruction-item m-1">
                  <div className="instruction-number instruction-marker me-2">2</div>
                  <div className="instruction-text">
                    Defina o intervalo de tempo para análise.
                  </div>
                </div>
                <div className="d-flex flex-row instruction-item m-1 mb-2">
                  <div className="instruction-number instruction-marker me-2">3</div>
                  <div className="instruction-text">
                    Escolha o tipo de solo (exemplo: argiloso, médio ou arenoso).
                  </div>
                </div>
                <strong>OBS</strong>
                : A escolha do tipo de solo é opcional, caso não concordar com o valor de CAD
                definido automaticamente, de acordo com nosso banco de dados, para a localidade
                escolhida.
                <p className="mt-3"><strong>Consulta por mapas</strong></p>
                <div className="d-flex flex-row instruction-item m-1 mt-2">
                  <div className="instruction-number instruction-marker me-2">1</div>
                  <div className="instruction-text">Informe o período desejado para análise.</div>
                </div>
                <div className="d-flex flex-row instruction-item m-1">
                  <div className="instruction-number instruction-marker me-2">2</div>
                  <div className="instruction-text">
                    Selecione a variável desejada:
                  </div>
                </div>
                <ul>
                  <li>Armazenamento (consulta de um único dia por vez).</li>
                  <li>Déficit hídrico (soma dos valores ao longo do período selecionado).</li>
                  <li>Excedente hídrico (soma dos valores ao longo do período selecionado).</li>
                  <li>
                    Saldo do balanço hídrico (diferença entre excedente e déficit ao longo do
                    período selecionado).
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
